// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3BCzV","img":"Card_img__qr-qd","title":"Card_title__2pVhP","list":"Card_list__2Tv72","dietList":"Card_dietList__3aiuP"};